import { userHelper, pricebookHelper } from '../helpers';

class ConfigurationAPI {
  constructor() {
    const authUser = userHelper.getStorage();
    const pricebook = pricebookHelper.getStorage();
    const existPricebook = Boolean(Object.keys(pricebook).length > 0);
    this.pricebook = authUser.isAuth && existPricebook ? pricebook : '';
    this.store = authUser.isAuth ? authUser.user.config.store : '';
    this.token = authUser.isAuth ? authUser.token : '';
    this.domain = authUser.isAuth ? authUser.domain : '';

    this.protocol = 'https';
    this.module = 'comercia_ws';
    this.credentials = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      headers: {
        Authorization: `Basic ${this.token}`,
        almacen: this.store.crmid,
        pricebook: this.pricebook.crmid,
      },
    };
    this.url = `${this.protocol}://${this.domain}/${this.module}`;
    this.mainUrl = `${this.protocol}://${this.domain}`;
  }
}

export default ConfigurationAPI;
